export const ADD_RUTAS_CLIENTE = 'fuerzaventas/rutas/add-rutas-cliente';
export const CLEAN_FORM = 'fuerzaventas/rutas/clean-form';
export const DROP_RUTA_CLIENTE = 'fuerzaventas/rutas/drop-ruta-cliente';
export const ERROR_RUTAS_LIST = 'fuerzaventas/rutas/error-rutas-list';
export const RECEIVE_RUTAS_LIST = 'fuerzaventas/rutas/receive-rutas-list';
export const REQUEST_RUTAS_LIST = 'fuerzaventas/rutas/request-rutas-list';
export const SET_ENTITY = 'fuerzaventas/rutas/set-entity';
export const SET_ERROR = 'fuerzaventas/rutas/set-error';
export const SET_MASK = 'fuerzaventas/rutas/set-mask';
export const SET_ORDER = 'fuerzaventas/rutas/set-order';
export const SET_PAGE = 'fuerzaventas/rutas/set-page';
export const SET_PAGE_SIZE = 'fuerzaventas/rutas/set-page-size';
export const SET_SELECTED_ROW = 'fuerzaventas/rutas/set-selected-row';
export const SET_STATE_FORM = 'fuerzaventas/rutas/set-state-form';
export const UPDATE_FIELD_ENTITY = 'fuerzaventas/rutas/update-field-entity';
export const UPDATE_FIELD_FILTER = 'fuerzaventas/rutas/update-field-filter';
export const UPDATE_RUTA_CLIENTE = 'fuerzaventas/rutas/update-ruta-cliente';
export const UPDATE_TABLE_COLUMN = 'fuerzaventas/rutas/update-table-column';